import { FormattedMessage } from 'react-intl';

import settingsIcon from '@/public/images/icons/settings-04.svg';

import style from './style.module.scss';

const UnitFilterButton = (props: any) => {
  const { hasFilter } = props;
  return (
    <div
      className={style.sizeHelpBtnContainer}
      data-bs-toggle="modal"
      data-bs-target="#SvFilterModalUnit"
    >
      <img src={settingsIcon.src} alt="info-icon" />
      <div className={style.title}>
        <FormattedMessage id="filter" />
      </div>
      {!hasFilter && <div className={style.filterDot} />}
    </div>
  );
};

export default UnitFilterButton;
